<template>
	<div ref="charts"></div>
</template>

<script>
	import {getStore, mapStore} from './store.js'
	import echarts from 'echarts'
	
	export default {
		data() {
			return {
				...getStore(this, 'digitalStore')
			}
		},

		computed: {
			...mapStore('digitalStore', ['registerChart', 'px'])
		},

		mounted() {
			this.echartsObj = echarts.init(this.$refs.charts);
			this.registerChart(this.echartsObj);
		},

		methods: {
			update() {
				this.request({
					url: '/visual/data/user/type',
					success: data => {
						this.echartsObj.clear();
						this.echartsObj.setOption({
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									type: 'shadow'
								}
							},
							legend: {
								show: true,
								top: this.px(0),
								right: this.px(-4),
								icon: 'rect',
								itemWidth: this.px(14),
								itemHeight: this.px(6),
								textStyle: {
									fontSize: this.px(12),
									color: '#fff'
								}
							},
							grid: {
								top: this.px(10),
								bottom: this.px(25),
								left: this.px(55),
								right: this.px(20)
							},
							yAxis: {
								type: 'value',
								axisLine: {
									show: false
								},
								axisLabel: {
									fontSize: this.px(13),
									color: '#ABFFE9'
								},
								splitLine: {
									lineStyle: {
										color: 'rgba(255,255,255,.05)'
									}
								}
							},
							xAxis: {
								type: 'category',
								axisLine: {
									show: true,
									lineStyle: {
										color: '#ABFFE9'
									}
								},
								axisLabel: {
									fontSize: this.px(12),
									color: '#ABFFE9',
                                    show: true,
                                    interval: 0, // 强制显示所有标签
                                    rotate: 0, // 标签旋转20度
                                    formatter: function(params) {
                                        var newParamsName = "";
                                        var paramsNameNumber = params.length;
                                        var provideNumber = 4; //一行显示几个字
                                        var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                                        if (paramsNameNumber > provideNumber) {
                                            for (var p = 0; p < rowNumber; p++) {
                                                var tempStr = "";
                                                var start = p * provideNumber;
                                                var end = start + provideNumber;
                                                if (p == rowNumber - 1) {
                                                    tempStr = params.substring(start, paramsNameNumber);
                                                } else {
                                                    tempStr = params.substring(start, end) + "\n";
                                                }
                                                newParamsName += tempStr;
                                            }
                                        } else {
                                            newParamsName = params;
                                        }
                                        return newParamsName;
                                    }
								},
								data: data.map(item => item.level_name)
							},
							series: {
								type: 'bar',
								barWidth: this.px(24),
								itemStyle: {
									normal: {
										barBorderRadius: [4, 4, 0, 0],
										color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
											offset: 0,
											color: '#00C365'
										}, {
											offset: 1,
											color: '#00FF4E'
										}], false)
									}
								},
								data: data.map(item => item.user_count)
							}
						});
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>